import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";

import { modalVariants } from "../../../Utils/constants";

function AccountDetailsContent({ accountNumber, routingNumber, initialShowAccount = false }) {
  const [showAccount, setShowAccount] = useState(initialShowAccount);
  const [copiedField, setCopiedField] = useState(null);

  const maskedAccount = accountNumber.length > 4
    ? "••••••" + accountNumber.slice(-4)
    : accountNumber;

  return (
    <div className="acdt-content">
      <div className="acdt-section">
        <div className="acdt-label">Account Number</div>
        <div className="acdt-value-row">
          <div className="acdt-value">{showAccount ? accountNumber : maskedAccount}</div>
          <div className="acdt-actions">
            <CopyToClipboard
              text={accountNumber}
              onCopy={() => {
                setCopiedField("account");
                setTimeout(() => setCopiedField(null), 1500);
              }}
            >
              <button className={`acdt-action-btn${copiedField === "account" ? " copied" : ""}`} type="button">
                {copiedField === "account" ? (
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M3 7.5L5.5 10L11 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <rect x="1" y="1" width="8" height="8" rx="1.5" stroke="#636879" strokeWidth="1.1" />
                    <rect x="5" y="5" width="8" height="8" rx="1.5" stroke="#636879" strokeWidth="1.1" />
                  </svg>
                )}
                {copiedField === "account" ? "Copied" : "Copy"}
              </button>
            </CopyToClipboard>
            <button
              className="acdt-action-btn"
              type="button"
              onClick={() => setShowAccount((v) => !v)}
              aria-label={showAccount ? "Hide account number" : "Show account number"}
            >
              {showAccount ? (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
                  <path
                    d="M1 7s2.35-3.25 6-3.25S13 7 13 7s-2.35 3.25-6 3.25S1 7 1 7Z"
                    stroke="#636879"
                    strokeWidth="1.1"
                    strokeLinejoin="round"
                  />
                  <circle cx="7" cy="7" r="1.35" stroke="#636879" strokeWidth="1.1" />
                  <path d="M2.5 11.5L11.5 2.5" stroke="#636879" strokeWidth="1.1" strokeLinecap="round" />
                </svg>
              ) : (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
                  <path
                    d="M1 7s2.35-3.25 6-3.25S13 7 13 7s-2.35 3.25-6 3.25S1 7 1 7Z"
                    stroke="#636879"
                    strokeWidth="1.1"
                    strokeLinejoin="round"
                  />
                  <circle cx="7" cy="7" r="1.35" stroke="#636879" strokeWidth="1.1" />
                </svg>
              )}
              {showAccount ? "Hide" : "Show"}
            </button>
          </div>
        </div>
      </div>

      <div className="acdt-divider" />

      <div className="acdt-section">
        <div className="acdt-label">Routing Number</div>
        <div className="acdt-value-row">
          <div className="acdt-value">{routingNumber}</div>
          <div className="acdt-actions">
            <CopyToClipboard
              text={routingNumber}
              onCopy={() => {
                setCopiedField("routing");
                setTimeout(() => setCopiedField(null), 1500);
              }}
            >
              <button className={`acdt-action-btn${copiedField === "routing" ? " copied" : ""}`} type="button">
                {copiedField === "routing" ? (
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M3 7.5L5.5 10L11 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <rect x="1" y="1" width="8" height="8" rx="1.5" stroke="#636879" strokeWidth="1.1" />
                    <rect x="5" y="5" width="8" height="8" rx="1.5" stroke="#636879" strokeWidth="1.1" />
                  </svg>
                )}
                {copiedField === "routing" ? "Copied" : "Copy"}
              </button>
            </CopyToClipboard>
          </div>
        </div>
      </div>

    </div>
  );
}

export default function renderAccountDetails(modalContext, stakeDebit = {}, { initialShowAccount = false } = {}) {
  const { updateModalComponent, setModalVariant, setModalTitle, setModalClassName } = modalContext;

  const accountNumber = stakeDebit?.data?.account_number ?? "";
  const routingNumber = stakeDebit?.data?.routing_number ?? "";

  updateModalComponent(() => (
    <AccountDetailsContent accountNumber={accountNumber} routingNumber={routingNumber} initialShowAccount={initialShowAccount} />
  ));
  setModalVariant(modalVariants.infoDialog);
  setModalTitle("Account Details");
  setModalClassName("account-details-modal");
}
